<template>
  <v-row>
    <!-- kitchen sink -->
    <v-col cols="12">
      <app-card-code
        :title="`${$t('menu.nomenclador')} / ${$t('menu.flights')} / ${$t('menu.suplementos')}`"
      >
        <SuplementosList></SuplementosList>
      </app-card-code>
    </v-col>
  </v-row>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

import SuplementosList from './tablas/SuplementosList.vue'

export default {
  components: {
    AppCardCode,
    SuplementosList,
  },
}
</script>
